import { useBranding } from "@/hooks/useBranding";

const BrandText = ({ type = "systemName", fallback = "IMS People Possible AI" }) => {
  const { branding } = useBranding();

  const text = (() => {
    if (type === "systemName") return branding?.appName || branding?.displayName || fallback;
    return branding?.displayName || branding?.appName || fallback;
  })();

  return <>{text}</>;
};

export default BrandText;
